"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCMSEventObj = exports.sendCMSEvent = exports.checkEventObj = exports.eventTypes = exports.createEventObject = exports.createPageEventObject = void 0;

var _uuid = require("uuid");

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

var _constants = require("../constants");

var _common = require("../common");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const getUUID = () => {
  const v1options = {
    node: [0x01, 0x23, 0x45, 0x67, 0x89, 0xab],
    clockseq: 0x1234,
    msecs: new Date().getTime(),
    nsecs: 5678
  };
  let uuid = (0, _uuid.v1)(v1options);
  uuid = uuid.replace(/-/g, '');
  uuid = uuid.toUpperCase();
  return uuid;
};
/**
 * Crea el objeto que hay que mandar a Métricas para un evento de Página
 * @param {Object} data con todos los parámetros necesarios.
 */


const createPageEventObject = data => {
  const {
    clientIDs,
    userType: userTypeFromData
  } = data;
  const {
    event = 'cms-page',
    eventType = '',
    tabId = '',
    pageName = '',
    pageProductCode = '',
    pageProductName = '',
    contextGaCookie = clientIDs && clientIDs.ga || null,
    contextSessionId = clientIDs && clientIDs.sessId || null,
    contextPageId = clientIDs && clientIDs.pageId || null,
    userCUCFijoHash = '',
    userCUCMovilHash = '',
    userCUCPrepagoHash = '',
    userIPHash = '',
    userOperadorHash = '',
    userTelefonoFijoHash = '',
    userTelefonoMovilHash = '',
    userIdPartyHash = '',
    userType = '',
    userConsentCookieOneTrust = '',
    pageSegment = '',
    contextURL = '',
    userClient = !!userTypeFromData,
    userPriority = '',
    contextSeoMeta = ''
  } = data;
  return {
    event,
    'event-type': eventType,
    'context-tab-id': tabId,
    'page-name': pageName,
    'page-product-code': pageProductCode,
    'page-product-name': pageProductName,
    // client id de ga
    'context-ga-cookie': contextGaCookie,
    // id de sesión de la navegación del usuario
    'context-session-id': contextSessionId,
    // page id de la página
    'context-page-id': contextPageId,
    'user-cuc-fijo-hash': userCUCFijoHash,
    'user-cuc-movil-hash': userCUCMovilHash,
    'user-cuc-prepago-hash': userCUCPrepagoHash,
    'user-ip-hash': userIPHash,
    'user-operador-hash': userOperadorHash,
    'user-telefono-fijo-hash': userTelefonoFijoHash,
    'user-telefono-movil-hash': userTelefonoMovilHash,
    'user-id-party-hash': userIdPartyHash,
    // telco o legado
    'user-type': userType,
    // estado consentimientos cookies del usuario
    'user-consent-cookie-onetrust': userConsentCookieOneTrust,
    // segmento de navegación de la página
    'page-segment': pageSegment,
    // url de la página
    'context-url': contextURL,
    // true o false si es cliente o no
    'user-client': userClient,
    // true o false si es priority o no
    'user-priority': userPriority,
    // meta description de seo
    'context-seo-meta': contextSeoMeta
  };
};
/**
 * Crea el objeto con la estructura adecuada para un evento de componente de métricas
 * @param {String} eventType
 * @param {String} componentName
 * @param {String} componentVariation
 * @param {String} componentContent
 * @param {String} componentProduct
 * @param {Object} componentPerso
 * @param {String} event
 */


exports.createPageEventObject = createPageEventObject;

const createEventObject = inputObj => {
  const res = {
    event: 'cms-component'
  };
  const keys = inputObj ? Object.keys(inputObj) : [];
  keys.forEach(key => {
    const resKey = (0, _common.toKebabCase)(key);
    const resValue = inputObj[key];
    res[resKey] = typeof resValue === 'string' ? resValue.toLowerCase() : resValue;
    res[resKey] = res[resKey] ? res[resKey] : '';
  });
  return res;
};

exports.createEventObject = createEventObject;
const requiredKeys = ['componentName', 'componentVariation', 'componentContent', 'componentProduct'];
const eventTypes = {
  CLICK: 'click',
  SCROLL: 'scroll'
};
exports.eventTypes = eventTypes;

const checkEventObj = taggingInfo => {
  let res = true;
  requiredKeys.forEach(key => {
    if (typeof taggingInfo[key] === 'undefined') {
      res = false;
    }
  });

  if (taggingInfo.debug) {
    res = true;
  }

  return res;
};
/**
 * Envía a la cola adecuada de métricas un evento de componente.
 * @param {*} eventType
 * @param {*} componentName
 * @param {*} componentVariation
 * @param {*} componentContent
 * @param {*} componentProduct
 * @param {*} componentPerso
 */


exports.checkEventObj = checkEventObj;

const sendCMSEvent = inputObj => {
  const checkObj = checkEventObj(inputObj);
  const object = createEventObject(inputObj);

  try {
    if (checkObj) {
      window.nookInfoExchange.sendMessage('Metrics', object);
    } else {
      (0, _gerenciatdUtils.errorLog)('TaggingInfo is no properly defined', '[checkEventObj] no right event structure');
    }
  } catch (err) {// TODO monirorizar donde toque.
  }
};

exports.sendCMSEvent = sendCMSEvent;

const buildCMSEventObj = (kind = 'print', status, eventFamily = 'cms-component', id, customizerId, taggingInfo) => {
  const componentUuid = getUUID();
  const newEvent = `${kind}-${status}`;

  const event = _objectSpread(_objectSpread({}, taggingInfo), {}, {
    event: eventFamily,
    eventType: newEvent,
    componentUuid
  });

  if (id) {
    event.componentName = id;
  }

  event.customizerId = customizerId;

  if (status === _constants.NETWORK_STATUS.FETCHING) {
    event.componentUuid = componentUuid;
  } // set necesary props to avoid checkEventObj


  if (!event.componentName) {
    event.componentName = '';
  }

  if (!event.componentVariation) {
    event.componentVariation = '';
  }

  if (!event.componentContent) {
    event.componentContent = '';
  }

  if (!event.componentProduct) {
    event.componentProduct = '';
  }

  return event;
};

exports.buildCMSEventObj = buildCMSEventObj;

//# sourceMappingURL=index.js.map